var keyMirror = require('keymirror');

module.exports = keyMirror({
	LOCAL_ACTION_CONVERSION_HISTOGRAM: null,
	LOCAL_ACTION_HISTO_CSV: null
});